import React from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { AccessTime } from '@mui/icons-material';
import { phoneMediaQuery, rescheduleTheme } from '../rescheduleTheme';
import { RescheduleTypography } from './RescheduleTypography';

type PolicyNoticeProps = {
  variant: 'free' | 'fee';
  text: string;
};

export const PolicyNotice = ({ variant, text }: PolicyNoticeProps) => {
  const isPhone = useMediaQuery(phoneMediaQuery);
  const isFee = variant === 'fee';
  const ink = isFee ? rescheduleTheme.warnInk : rescheduleTheme.brand;

  return (
    <Grid
      container
      flexWrap="nowrap"
      alignItems="flex-start"
      sx={{
        gap: isPhone ? '10px' : '12px',
        padding: isPhone ? '12px 14px' : '14px 16px',
        borderRadius: `${rescheduleTheme.radii.control}px`,
        background: isFee ? rescheduleTheme.warnBg : rescheduleTheme.brandTint,
        color: ink,
      }}>
      <AccessTime aria-hidden="true" sx={{ flex: 'none', fontSize: isPhone ? '18px' : '20px', marginTop: '1px' }} />
      <RescheduleTypography style={{ fontSize: isPhone ? 14 : 15, lineHeight: isPhone ? 1.45 : 1.5 }}>
        {text}
      </RescheduleTypography>
    </Grid>
  );
};
